import GroupLayout from "./GroupLayout";

const EuroLayout = () => (
  <GroupLayout
    brandName="Euro"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/euro-logo.png"
    groupId="10000000020"
    headline="Euro International Group of Institutions"
  />
);

export default EuroLayout;
